import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    bookingUrl: '' as string,
    bookingBlockUrl: ''as string,
    initialValues: { year: null, accountId: null, bookingNr: null},
    accountRowData: null as any,
    allRowsSum: null as any,
    activeBalanceButton: 2,
    activeContraAccount: 0,
    activeRevertedBookings: 0,
    balanceLabel: 'global:label.accountStatement.balance',
    activeDivRef: null as any
}

const statementFiltersSlice = createSlice({
    name: 'statementFilters',
    initialState,
    reducers: {
        setBookingUrl: (state, action) => {
            state.bookingUrl = action.payload
        },
        setBookingBlockUrl: (state, action) => {
            state.bookingBlockUrl = action.payload
        },
        setInitialValues: (state, action) => {
            state.initialValues = {...state.initialValues, ...action.payload}
        },
        setAccountRowData: (state, action) => {
            state.accountRowData = action.payload
        },
        setAllRowsSum: (state, action) => {
            state.allRowsSum = action.payload
        },
        setactiveBalanceButton: (state, action) => {
            state.activeBalanceButton = action.payload
        },
        setActiveContraAccount: (state, action) => {
            state.activeContraAccount = action.payload
        },
        setActiveRevertedBookings: (state, action) => {
            state.activeRevertedBookings = action.payload
        },
        setBalanceLabel: (state, action) => {
            state.balanceLabel = action.payload
        },
        setActiveDivRef: (state, action) => { 
            state.activeDivRef = action.payload
        }
    }
})

export const {
    setBookingUrl, setBookingBlockUrl, setInitialValues, setAccountRowData, setAllRowsSum, setActiveDivRef,
    setactiveBalanceButton, setBalanceLabel, setActiveContraAccount, setActiveRevertedBookings } = statementFiltersSlice.actions
export default statementFiltersSlice.reducer
